import { useIntl } from 'react-intl';
import SummaryTable, { SummaryRow } from '../../table/SummaryTable';
import formatSummaryRowByKey from '../../../../../../modules/helpers/FormatSummaryRowByKey';

interface Props {
  data: any;
  status: string;
  refetch: () => void;
}

export default function Detail({ data, status, refetch }: Props) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id: `SI_DOMAIN.${id}` });
  const emDash = '—';

  const detailSection: SummaryRow[] = [...formatSummaryRowByKey(data?.result?.domain_detail)];

  return (
    <div className='card mb-5 mb-xl-10 border'>
      <div className='card-header align-items-center justify-content-start'>
        <h4 className='my-6'>{t('APPENDIX_A_WHOIS_RECORD')}</h4>
      </div>
      <div className='card-body p-9 d-flex flex-column gap-9'>
        <SummaryTable rows={detailSection} data={data} refetch={refetch} className='gb-0' />
      </div>
      <div className='d-flex justify-content-end mb-5'>
        <a href='#summary' className='px-8 d-none print-display-button'>
          <i className="bi bi-caret-up-square-fill fs-3"></i>
        </a>
      </div>
    </div>
  );
}
